;(function(undefined) {

    var _initBridge = false;

    function SmartCity(){}
  
    function setupWebViewJavascriptBridge(callback) {
        if (window.WebViewJavascriptBridge) {
            return callback(WebViewJavascriptBridge);
        }else{
            document.addEventListener('WebViewJavascriptBridgeReady', function() {
                return callback(WebViewJavascriptBridge);
            }, false);
        }
        if (window.WVJBCallbacks) {
            return window.WVJBCallbacks.push(callback);
        }
        window.WVJBCallbacks = [callback];
        var WVJBIframe = document.createElement('iframe');
        WVJBIframe.style.display = 'none';
        WVJBIframe.src = 'https://__bridge_loaded__';
        document.documentElement.appendChild(WVJBIframe);
        setTimeout(function() { document.documentElement.removeChild(WVJBIframe) }, 0)
    }
    
    function getMobileDevice(){
        var mbldevice = navigator.userAgent.toLowerCase()
        if (/iphone|ipod|ipad/gi.test(mbldevice)) {
            return 'iOS'
        } else if (/android/gi.test(mbldevice)) {
            return 'Android'
        } else {
            return 'other'
        }
    }

    function isSmartCity(){
        var mbldevice = navigator.userAgent.toLowerCase();
        if (/m2osmartcity/gi.test(mbldevice)) {
            return true;
        }else{
            return false;
        }
    }

    function callHandler(api, param, callback){
        if(!isSmartCity()){
            // alert('璇峰湪app涓墦寮€');
            return;
        }
        setupWebViewJavascriptBridge(function(bridge){
            if(typeof bridge.init != 'undefined' && bridge.init instanceof Function){
                if(!_initBridge){
                bridge.init(function(message, responseCallback) {});
                _initBridge = true;
                }
            }
            if (api == 'getLocation') {
                bridge.registerHandler('getLocation', function (response, responseCallback) {
                    response = typeof response === 'string' ? JSON.parse(response) : response;
                    callback && callback(response);
                    responseCallback('success');
                });
            }
            bridge.callHandler(api, param , function(response) {
                response = typeof response === 'string' ? JSON.parse(response) : response;
                callback && callback(response);
            });
        });
    }

    SmartCity.prototype = {

        constructor: this,

        //鍒ゆ柇鏄惁鍦ㄥ帤寤哄鎴风
        isSmartCityApp : function(){
            return isSmartCity();
        },

        //鑾峰彇鐢ㄦ埛淇℃伅
        getUserInfo : function(callback){
            callHandler('getUserInfo', null , function(response) {
                callback && callback(response);
            })
        },

        //鑾峰彇璁惧淇℃伅
        getSystemInfo : function(callback){
            callHandler('getSystemInfo', null , function(response) {
                callback && callback(response);
            })
        },

        //鑾峰彇浣嶇疆淇℃伅
        getLocation : function(callback){
            callHandler('getLocation', null , function(response) {
                callback && callback(response);
            })
        },

        //鍘荤櫥褰曢〉
        goLogin : function(){
            callHandler('goLogin', null , null);
        },

        //鍥炲埌涓婁竴椤�
        goBack : function(){
            callHandler('goBack', null , null);
        },

        //鎵撶數璇�
        makeCall : function(param){
            callHandler('makeCall', param , null);
        },

        //鍙戦偖浠�
        sendMail : function(param){
            callHandler('sendMail', param , null);
        },

        //鍙戠煭淇�
        makeMsm : function(param){
            callHandler('makeMsm', param , null);
        },

        //鍘荤敤鎴蜂腑蹇�
        goUcenter : function(){
            callHandler('goUcenter', null , null);
        },

        //閫€鍑哄綋鍓嶉〉闈�        
        goAbort : function(){
            callHandler('goAbort', null , null);
        },

        //杩斿洖棣栭〉
        goRoot : function(){
            callHandler('goRoot', null , null);
        },

        //鍒嗕韩
        shareTo : function(param){
            callHandler('shareTo', param , null);
        },

        //鍒嗕韩鎴愬姛
        onShareSuccess : function(callback){
            callHandler('onShareSuccess', null , function(response) {
                callback && callback(response);
            })
        },

        //鍐呴摼璺宠浆
        linkTo : function(param){
            callHandler('linkTo', param , null);
        },

        //鍘诲湴鍥�
        goMap : function(param){
            callHandler('goMap', param , null);
        },

        //澶у浘棰勮锛堝崟寮狅級
        clickImage : function(param){
            callHandler('clickImage', param , null);
        },

        //澶у浘棰勮锛堝崟寮狅級
        showBigImage : function(param){
            callHandler('showBigImage', param , null);
        },

        //鍥剧墖淇濆瓨
        saveImage : function(param){
            callHandler('saveImage', param , null);
        },

        //鏄剧ず鍒嗕韩鎸夐挳
        showShareBtn : function(param){
            callHandler('showShareBtn', param , null);
        },

        //闅愯棌瀵艰埅鏍�
        hideTopView : function(param){
            callHandler('hideTopView', param , null);
        },

        //鍏ㄥ睆鎾斁
        fullScreenPlay : function(param){
            callHandler('fullScreenPlay', param , null);
        },

        //娓呯┖鍘嗗彶淇℃伅
        clearHistory : function(){
            callHandler('clearHistory', null , null);
        },

        //鑾峰彇澶村姞瀵嗕俊鎭�
        getRequestHeader: function(callback){
            callHandler('getRequestHeader', null , function(response) {
                callback && callback(response);
            })
        },

        //閫夋嫨鍥剧墖
        chooseImage : function(param,callback){
            callHandler('chooseImage', param , function(response) {
                callback && callback(response);
            })
        },

        //鍥剧墖棰勮
        previewImage : function(param){
            callHandler('previewImage', param , null);
        },

        //鎵弿浜岀淮鐮�
        scanQRCode : function(callback){
            callHandler('scanQRCode', null , function(response) {
                callback && callback(response);
            })
        },

        //璺宠浆缁戝畾鎵嬫満鍙烽〉闈�
        goBind : function(){
            callHandler('goBind', null , null);
        },

        //璺宠浆浜鸿劯璇嗗埆瀹炲悕璁よ瘉缁勪欢
        goToAuthentication : function(callback){
            callHandler('goToAuthentication', null , function(response) {
                callback && callback(response);
            })
        },
        // 璺宠浆瀹炰汉璁よ瘉椤甸潰
        goToRealPersionAuth : function (param,callback) {
            callHandler('goToRealPersionAuth', param , function(response) {
                callback && callback(response);
            })
        },
        
        // 鑾峰彇姣忔棩杩愬姩閲� add by Neil@20220318
        getStepDayData : function(param, callback) {
            callHandler('getStepDayData', param, function(response) {
                callback && callback(response)
            })
        },

        // 鑾峰彇鍋ュ悍鏁版嵁 add by Neil@20220318
        getHealthDayData : function(param, callback) {
            callHandler('getHealthDayData', param, function(response) {
                callback && callback(response)
            })
        },

        //璺宠浆鎷嶇収椤甸潰
        goToCamera : function(param,callback){
            callHandler('goToCamera', param , function(response) {
                callback && callback(response);
            })
        },

        //璺宠浆娲讳綋璁よ瘉椤甸潰
        goToLivingStyle : function(callback){
            callHandler('goToLivingStyle', null , function(response) {
                callback && callback(response);
            })
        },

        //璇锋眰鎺ュ彛鏁版嵁
        requestApi : function(param,callback){
            callHandler('requestApi', param , function(response) {
                callback && callback(response);
            })
        },

        //鏄惁绂佹渚ф粦杩斿洖
        interactivePopDisabled : function(param){
            callHandler('interactivePopDisabled', param , null);
        },

        //鍙戦€佷簯缁熻鏁版嵁
        sendAnalysisData : function(param){
            callHandler('sendAnalysisData', param , null);
        },

        //璇锋眰璺宠浆瀛恆pp
        linkToSubApp : function(param){
            callHandler('linkToSubApp', param , null);
        },

        //鎾斁vr瑙嗛
        goVRPlayer : function(param){
            callHandler('goVRPlayer', param , null);
        },

        //鍔犺浇鎾斁鍣�
        embedVideoPlayer : function(param){
            callHandler('embedVideoPlayer', param , null);
        },

        //閿€姣佹挱鏀惧櫒
        destroyVideoPlayer : function(){
            callHandler('destroyVideoPlayer', null , null);
        },

        //鍔犺浇寮瑰箷
        loadBarrageData : function(param){
            callHandler('loadBarrageData', param , null);
        },

        //璇锋眰鎺ュ彛鏁版嵁
        getRelateNews : function(callback){
            callHandler('getRelateNews', null , function(response) {
                callback && callback(response);
            })
        },
  
        goSubscription : function(param,callback){
            callHandler('goSubscription', param , function(response) {
                callback && callback(response);
            })
        },
  
        getPraiseInfo : function(callback){
            callHandler('getPraiseInfo', null , function(response) {
                callback && callback(response);
            })
        },

        goPraise : function(){
            callHandler('goPraise', null , null)
        },

        getMyPraise : function(callback){
            callHandler('getMyPraise', null , function(response) {
                callback && callback(response);
            })
        },
  
        getDiggInfo : function(callback){
            callHandler('getDiggInfo', null , function(response) {
                callback && callback(response);
            })
        },
  
        getCommentList : function(callback){
            callHandler('getCommentList', null , function(response) {
                callback && callback(response);
            })
        },

        getCommentCount : function(callback){
            callHandler('getCommentCount', null , function(response) {
                callback && callback(response);
            })
        },
  
        getMoreComment : function(){
            callHandler('getMoreComment', null , null)
        },

        showCommentInput : function(param){
            callHandler('showCommentInput', param , null)
        },
  
        getSubsInfo : function(callback){
            callHandler('getSubsInfo', null , function(response) {
                callback && callback(response);
            })
        },
  
        newsZan : function(callback){
            callHandler('newsZan', null , function(response) {
                callback && callback(response);
            })
        },
  
        commentZan : function(param,callback){
            callHandler('commentZan', param , function(response) {
                callback && callback(response);
            })
        },
        
        commentReply : function(param){
            callHandler('commentReply', param , null)
        },
  
        digg : function(param,callback){
            callHandler('digg', param , function(response) {
                callback && callback(response);
            })
        },

        //鑾峰彇鐢佃骞垮憡
        getNewsDetailCDSPAd : function(callback){
            callHandler('getNewsDetailCDSPAd', null , function(response) {
                callback && callback(response);
            })
        },

        //璇绘柊闂�
        readNewsContent : function(param){
            callHandler('readNewsContent', param , null)
        },

        //璁剧疆瀛椾綋澶у皬
        setFontSize : function(param){
            callHandler('setFontSize', param , null)
        },

        //鑾峰彇澶滈棿妯″紡鐘舵€�
        getNightStatus : function(callback){
            callHandler('getNightStatus', null , function(response) {
                callback && callback(response);
            })
        },

        //铻嶅悎鍙疯烦杞�
        getSubsInfoOfPlus : function(param){
            callHandler('getSubsInfoOfPlus', param , null)
        },

        //璁㈤槄"璁㈤槄鐘舵€侊細0鎴栬€�1"
        goSubscriptionOfPlus : function(param,callback){
            callHandler('goSubscriptionOfPlus', param , function(response) {
                callback && callback(response);
            })
        },

        //鑾峰彇缃戞槗淇℃伅娴佺偣璧炴暟閲�
        getPraiseNum : function(callback){
            callHandler('getPraiseNum', null , function(response) {
                callback && callback(response);
            })
        },

        //鑾峰彇缃戞槗淇℃伅娴佺偣鍑婚噺
        getPraiseNum : function(callback){
            callHandler('getClickNum', null , function(response) {
                callback && callback(response);
            })
        },

        //鎵撹祻
        goToReward : function(){
            callHandler('goToReward', null , null);
        },

        getViewPagerInfo : function(param){
            callHandler('getViewPagerInfo', param , null);
        },

        //寮€濮嬪綍闊�
        startRecord : function(callback){
            callHandler('startRecord', null , function(response) {
                callback && callback(response);
            })
        },

        //鍋滄褰曢煶
        stopRecord : function(callback){
            callHandler('stopRecord', null , function(response) {
                callback && callback(response);
            })
        },

        //寮€濮嬫挱鏀�
        playVoice : function(param){
            callHandler('playVoice', param , null);
        },
        
        //缁撴潫鎾斁
        pauseVoice : function(param){
            callHandler('pauseVoice', param , null);
        },

        //涓婁紶鏂囦欢
        uploadFile : function(param,callback){
            callHandler('uploadFile', param , function(response) {
                callback && callback(response);
            })
        },

        //浜戦棯浠�
        appTLUnifyAllinpay : function(param){
            callHandler('appTLUnifyAllinpay', param , null);
        },

        //娴忚鍣ㄨ繑鍥炲姭鎸�
        stopUnload: function(param,callback){
            callHandler('stopUnload', param , function(response) {
                callback && callback(response);
            })
        },

        //闇囧姩鍙嶉
        vibrateFeedback: function(param,callback){
            callHandler('vibrateFeedback', param , function(response) {
                callback && callback(response);
            })
        },

        //鐘舵€佺鐞�
        applicationState: function(callback){
            callHandler('applicationState', null , function(response) {
                callback && callback(response);
            })
        },

        // 鎷嶈棰�
        videoRecording: function(param,callback) {
            callHandler('videoRecording', param , function(response) {
                callback && callback(response);
            })
        },

        //鍏抽棴web鐨勫脊鎬т笅鎷�
        closeWebViewBounces: function(param){
            callHandler('closeWebViewBounces', param , null);
        },
        // 娣诲姞蹇嵎鏂瑰紡鍒版闈�
        createShortCut: function (param) {
            callHandler('createShortCut', param , null)
        }
    }
    window.SmartCity = new SmartCity();
}());